import { ClickIcon } from './assets/icons/ClickIcon'
import { PayIcon } from './assets/icons/PayIcon'
import { ReturnIcon } from './assets/icons/ReturnIcon'

export const CDN_SPLIT_IMG_URL = `https://storage.yandexcloud.net/tf-bitrix-upload/iport/screens/split`
export const CDN_CATEGORY_IMG_URL = `https://storage.yandexcloud.net/tf-bitrix-upload/iport/categoryImages`

export const advantages = [
	{
		icon: <ClickIcon />,
		title: `В пару кликов`,
		subtitle: `Быстрое оформление <br/> без анкет и документов`
	},
	{
		icon: <ReturnIcon />,
		title: `Легко вернуть`,
		subtitle: `Заказ со сплитом так же просто вернуть, как и без него`
	},
	{
		icon: <PayIcon />,
		title: `Без переплат`,
		subtitle: `На 2 месяца`
	}
]

export const categoriesListData = [
	{
		id: `103`,
		code: `iphone`,
		link: `/catalog/apple_iphone/`,
		title: `iPhone`,
		imgSrc: `${CDN_CATEGORY_IMG_URL}/iphoneCategoryImg.png`
	},
	{
		id: `76`,
		code: `mac`,
		link: `/catalog/apple_mac/`,
		title: `Mac`,
		imgSrc: `${CDN_CATEGORY_IMG_URL}/macCategoryImg.png`
	},
	{
		id: `86`,
		code: `ipad`,
		link: `/catalog/apple_ipad/`,
		title: `iPad`,
		imgSrc: `${CDN_CATEGORY_IMG_URL}/ipadCategoryImg.png`
	},

	{
		id: `115`,
		code: `watch`,
		link: `/catalog/apple_watch/`,
		title: `Watch`,
		imgSrc: `${CDN_CATEGORY_IMG_URL}/watchCategoryImg.png`
	},
	{
		id: `103`,
		code: `airpods`,
		link: `/catalog/naushniki/filter/airpods/`,
		title: `AirPods`,
		imgSrc: `${CDN_CATEGORY_IMG_URL}/airpodsCategoryImg.png`
	}
]

export const decription = `Яндекс Пэй — информационный сервис, позволяющий сохранять и использовать данные банковских карт. Подробнее в условиях использования сервиса. Сервис Яндекс Сплит предоставляется ООО «Яндекс.Сплит», ОГРН 1187746900428, 115035, г. Москва, ул. Садовническая, д. 82, стр. 2, пом. 5В26. Оформление заказа осуществляется в соответствии с договором поручения. Не является публичной офертой, есть ограничения на использование сервиса.`
